export interface LiquidateAllDialogProps {
  open: boolean;
  openCount: number;
  hiddenByFilterCount: number;
  cancelOrders: boolean;
  submitting: boolean;
  errorMessage?: string;
  onOpenChange: (open: boolean) => void;
  onCancelOrdersChange: (checked: boolean) => void;
  onConfirm: () => void;
}

export interface LiquidateAllDialogController extends LiquidateAllDialogProps {
  confirmDisabled: boolean;
  confirmLabel: string;
}

export const useLiquidateAllDialogController = (
  props: LiquidateAllDialogProps,
): LiquidateAllDialogController => ({
  ...props,
  confirmDisabled: props.submitting || props.openCount === 0,
  confirmLabel: props.submitting ? "Liquidating…" : "Liquidate all",
});
